import type { SVGProps } from "react";

/** The 4-point spark logo mark (design-system.md §4 → Iconography). Lime. */
export function Spark({ size = 20, ...props }: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      {...props}
    >
      <path
        d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"
        fill="var(--ge-accent)"
      />
    </svg>
  );
}

/** Full wordmark lockup: spark + "GROWTH ENGINE". */
export function Wordmark({ className }: { className?: string }) {
  return (
    <div className={className} style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <Spark size={20} />
      <span className="font-sans text-[14px] font-bold tracking-ge-brand text-ge-primary">
        GROWTH ENGINE
      </span>
    </div>
  );
}
